export const frCataloguesAsCatalogues = {
    'navbar.collections': 'Catalogues',
    'collections.name': 'Catalogue',
    'collections.title': 'Catalogues',

    //* COLLECTION LIST
    'collections.list.pageTitle': 'Catalogues',
    'collections.list.actions.addCollection': 'Créer un catalogue',
    'collections.list.table.emptyLabel': "Il n'y a pas de catalogue pour le moment",

    //* COLLECTION INFORMATIONS
    'collections.info.description': 'Saisissez ici la description du catalogue',
    'collections.info.owner.select.title': 'Sélectionnez le propriètre du catalogue',

    //* COLLECTION NOTIFICATIONS // MANUAL
    'collections.notifs.manualInfo': "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté le catalogue.",

    //* COLLECTION >> CREATE AND DETAILS
    'collections.create.pageTitle': 'Création catalogue',
    'collections.details.pageTitle': 'Détails catalogue',
    'collections.details.actions.previous': 'Catalogues',

    'collections.remove.dialog.title': 'Suppression de le catalogue',
    'collections.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce catalogue ?',

    //* COLLECTION PERMISSIONS
    'backofficeUsers.permissions.collections.contentcreate': 'Création de catalogue',

    //* ERRORS
    'toast.apiErrors.COLLECTION_MUST_HAVE_ONE_PRODUCT_AT_LEAST': 'Un catalogue doit avoir au moins un produit',
};
